import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-8" }, null, -1)
const _hoisted_2 = { class: "flex-1 text-center flex items-center justify-center" }
const _hoisted_3 = { class: "font-semibold text-black" }

import useLge from '@/embr/lbp/composables/useLge';
import { GqlLge } from '@/embr/services/embr/embr-types';
import { FullPool } from '@/services/balancer/subgraph/types';

type Props = {
  lge: GqlLge;
  pool: FullPool;
};


export default _defineComponent({
  props: {
    lge: { type: null, required: true },
    pool: { type: null, required: true }
  } as unknown as undefined,
  setup(__props: {
  lge: GqlLge;
  pool: FullPool;
}) {

const props = __props


const {
  isBeforeStart,
  isAfterEnd,
  startDateTimeFormatted,
  endDateTimeFormatted
} = useLge(props.lge, props.pool);

return (_ctx: any,_cache: any) => {
  return (_unref(isBeforeStart) || _unref(isAfterEnd))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
      'app-nav-alert text-white',
      _unref(isBeforeStart) ? 'bg-green-500' : 'bg-red-600'
    ])
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(props.lge.name) + " Liquidity Bootstrapping Pool " + _toDisplayString(_unref(isBeforeStart) ? ' starts' : ' ended') + ": " + _toDisplayString(`${_unref(isBeforeStart) ? _unref(startDateTimeFormatted) : _unref(endDateTimeFormatted)}`), 1)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})